import { defineMessages } from 'react-intl'

/**
 * Tour style names, “Key benefits” copy, and tour-UX strings — `docs/product-taxonomy.md` §7.
 * Pair with `useTourStyledLabels` / `useTourStyleBenefits` for headings already inlined there.
 */
const tourGlossaryMessages = defineMessages({
  deluxeTours: {
    id: 'dHUnXgQ7nMqRg_ohkf8u',
    defaultMessage: 'Deluxe Tours',
    description: 'Tour category title for deluxe-tier tour collections on the tours landing and PDP',
  },
  premiumTours: {
    id: 'PyZp5DtcHRPJ_kdD-nB3',
    defaultMessage: 'Premium Tours',
    description: 'Tour category title for premium-tier tour collections on the tours landing and PDP',
  },
  signatureSeriesTours: {
    id: 'KK-ng704V1N6RbM6-RBa',
    defaultMessage: 'Signature Series',
    description: 'Tour category title for the Signature Series collection in merchandising and nav',
  },
  insiderSeriesTours: {
    defaultMessage: 'Insider Series Tours',
    id: 'nCK-jFI8LsRT_PXYduFN',
    description: 'Tour category title for the Insider Series collection on marketing and product surfaces',
  },
  ultraLuxTours: {
    id: 'Zr_5o6AxrNXLAhDAui0Y',
    defaultMessage: 'Ultra Lux Tours',
    description: 'Tour category title for ultra-luxury tour styles on the tours vertical',
  },
  privateDeluxeTours: {
    defaultMessage: 'Private Deluxe Tours',
    id: '0TtDAItXN0Ops1JZADFr',
    description: 'Private-journey marketing title for deluxe private tour product lines on the tour PDP',
  },
  privatePremiumTours: {
    defaultMessage: 'Private Premium Tours',
    id: 'mcArzAmecNsi3LoE7GaT',
    description: 'Private-journey marketing title for premium private tour product lines on the tour PDP',
  },
  privateSignatureSeriesTours: {
    defaultMessage: 'Private Signature Series Tours',
    id: 'FTJOLg5mfdrA0ok5Rpbs',
    description: 'Private-journey title for private Signature Series tour product lines on the tour PDP',
  },
  privateInsiderSeriesTours: {
    defaultMessage: 'Private Insider Series Tours',
    id: 'MFCwgUIbmhTJlhdswxo7',
    description: 'Private-journey title for private Insider Series tour lines on the tour PDP',
  },
  privateUltraLuxTours: {
    defaultMessage: 'Private Ultra Lux Tours',
    id: 'I62GY03s_FbqSaDrBmYg',
    description: 'Private-journey title for private ultra-luxury tour product lines on the tour PDP',
  },
  keyBenefitsOf: {
    defaultMessage: 'Key Benefits of {tourVariantName}',
    id: 'QqnfeKvO-uiwZSsVAniC',
    description: 'Section heading template for tour style key benefits on tour product detail pages',
  },
  toursConcierge: {
    defaultMessage: 'Tours Concierge',
    id: 'wt7EMrSVk5Jp3a6UEjTs',
    description: 'Label for the dedicated tours concierge support feature in sales and help touchpoints',
  },
  preTourAccommodationIn: {
    defaultMessage: 'Pre-tour accommodation in {location}',
    id: 'GjpEu5u0jQyidbZiRv8N',
    description: 'Line item describing pre-tour hotel or stay location before the main tour departs',
  },
  postTourAccommodationIn: {
    defaultMessage: 'Post-tour accommodation in {location}',
    id: '4_rzAcIUd-KSInHa6bvv',
    description: 'Line item describing post-tour stay location after the main tour leg completes',
  },
  tourPlusFlightsPackage: {
    defaultMessage: 'Tour + flights package available',
    id: 'CaPpoUkWpCltU94a7SnF',
    description: 'Merchandising line when a tour can be sold bundled with flights on the offer page',
  },
  putTourOnHold: {
    defaultMessage: 'Put tour on hold',
    id: 'iaSbsJcuQYnYMsLX3gcE',
    description: 'Action to place a tour booking on hold from cart or sales-assisted flows where offered',
  },
  removeTour: {
    defaultMessage: 'Remove tour',
    id: 'mddJWoQQ_wRHfvbg1itc',
    description: 'Action to remove a selected tour from the cart, itinerary, or multi-leg booking',
  },
  extrasOnYourTour: {
    defaultMessage: 'Extras on your tour',
    id: 'nuiRlRfGn3m7QaGj6jFY',
    description: 'Section heading for optional add-ons and upgrades attached to a tour purchase',
  },
  privateTour: {
    defaultMessage: 'Private tour',
    id: 'y59ehJqEchYieT2zE7AO',
    description: 'Tour group-size taxonomy label for private departure tour products in filters and PDP',
  },
  smallGroupTour: {
    defaultMessage: 'Small group tour',
    id: 'pqPcse8RsgxR9UilKj-2',
    description: 'Tour group-size taxonomy label for small-group departures in search filters and copy',
  },
  largeGroupTour: {
    defaultMessage: 'Large group tour',
    id: '-ZI0P_VOXj2sr_sPAy7X',
    description: 'Tour group-size taxonomy label for large-group departures in search filters and copy',
  },
  familyFriendlyTour: {
    defaultMessage: 'Family friendly tour',
    id: 'Dk-jbNRC6plcOwu4zMXr',
    description: 'Tour audience taxonomy label for family-friendly tour products in filters and search',
  },
})

export default tourGlossaryMessages
